import * as React from 'react';
import { Box, Modal, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { modalStyles } from './styles';

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  actionButtons: React.ReactNode;
  // Read the content out when the dialog opens. For a short message; a form would be read field by field.
  describedByContent?: boolean;
}

const ModalPopup = (props: Props) => {
  const { open, onClose, title, children, actionButtons, describedByContent = false } = props;
  const titleId = React.useId();
  const contentId = React.useId();
  // MUI's Modal root is role="presentation", so the dialog role and its name go on the box it focuses (#163).
  return (
    <Modal open={open}>
      <Box
        sx={modalStyles.modalContainer}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        aria-describedby={describedByContent ? contentId : undefined}
      >
        {title ? (
          <Typography id={titleId} component="h1" variant="h6">
            {title}
          </Typography>
        ) : null}
        <Box id={contentId} sx={modalStyles.modalContent}>
          {children}
        </Box>
        <IconButton aria-label="Close" onClick={onClose} sx={modalStyles.closeIcon}>
          <Close />
        </IconButton>
        <Box sx={modalStyles.actionButtonsContainer}>{actionButtons}</Box>
      </Box>
    </Modal>
  );
};

export default ModalPopup;
